/* eslint-disable no-nested-ternary */
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { chancesOfAdmissionSelector } from '@ucheba/store/institutions/chancesOfAdmission'

import { ELoading } from '@ucheba/store/utils/response/types'

import { PROBABILITY_TYPES } from '../../constants'
import { TUseResultsList } from '../../types'

export const useResultsList: TUseResultsList = (insitutionName) => {
  const { currentProbability, programs, anotherPrograms } =
    useSelector(chancesOfAdmissionSelector.chancesOfAdmission) || {}

  const loading = useSelector(chancesOfAdmissionSelector.loading)

  const isLoadingList = useMemo(() => loading === ELoading.pending, [loading])

  const noSuitablePrograms = programs?.length === 0

  const probability = noSuitablePrograms
    ? 'noSuitablePrograms'
    : currentProbability > 90
      ? 'high'
      : currentProbability > 50
        ? 'medium'
        : 'low'

  const title = noSuitablePrograms
    ? `В ${insitutionName} нет подходящих программ`
    : isLoadingList
      ? `Ждём ваши шансы на поступление в <br/> ${insitutionName}`
      : `У вас ${PROBABILITY_TYPES[probability]} шансы поступить в <br/> ${insitutionName}`

  return {
    isLoadingList,
    probability,
    title,
    programs,
    anotherPrograms,
  }
}
